import React, { useEffect, useState } from 'react';
import { collection, doc, onSnapshot, orderBy, query, updateDoc } from 'firebase/firestore';
import { db } from '../../../../../../firebase';
import { Badge, Button, Form, InputGroup, Modal } from 'react-bootstrap';
import { MdAdd } from 'react-icons/md';
import { useAuth } from '../../../../../../context/AuthContext';
import { format } from 'date-fns';

const PaymentPlans = ({ propertyItems, planID, handleShowPayment, setPlanID }) => {

  const { user, settings } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(true);
  const [paymentTerms, setPaymentTerms] = useState(0);
  const [dueDate, setDueDate] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [data, setData] = useState(null);

  const [showAction, setShowAction] = useState(false);

  function getPayments() {
    const q = query(collection(db, "Businesses", bid, "Properties", propertyItems.id, "PaymentPlans", planID, "Payments"), orderBy("serialNumber"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, completionDate: new Date(), ...doc.data() });
      });

      setData(tempData);
    }, (error) => {
      console.log(error.message);
      setIsLoading(false);
    });

    return () => unsubscribe;
  }

  useEffect(() => {
    getPayments();

    if (settings) {
      settings.forEach(doc => {
        if (doc.id === 'general') {
          setPaymentTerms(doc.paymentTerms);
          setDueDate(new Date());
        }
      });
    }
  }, [settings]);

  async function handlePaymentAction(calculatedDueDate) {
    try {
      const docRef = doc(db, "Businesses", bid, "Properties", propertyItems.id, "PaymentPlans", planID, "Payments", selectedPayment.id);
      await updateDoc(docRef, {
        isCompleted: true,
        completionDate: selectedPayment.completionDate,
        nextPaymentDueDate: new Date(calculatedDueDate),
        paymentTerms: paymentTerms
      });
      setShowAction(false);
      setSelectedPayment(null);
    } catch (error) {
      console.log('Progress Update [Error] :', error);
    } finally {
      // START EXCUTE NOTIFICATION CODE TO SEND NOTIFICATION TO CUSTOMERS
      //
      //
      //      CODE HERE....
      //
      //
      // END EXCUTE NOTIFICATION CODE TO SEND NOTIFICATION TO CUSTOMERS
      console.log('Notification Excuted!!!');
    }
  }

  const calculatedDueDate = new Date(selectedPayment && selectedPayment.completionDate).setDate(new Date(selectedPayment && selectedPayment.completionDate).getDate() + parseInt(paymentTerms ? paymentTerms : 0));

  return (
    <>
      {
        data && data.length > 0 ?
          <>
            {
              data && data.map((items, index) => {
                return (
                  <Button
                    disabled={items.isCompleted}
                    key={index}
                    variant='light'
                    className={index === 0 ? 'rounded-0 w-100 px-2 py-3' : 'rounded-0 w-100 px-2 py-3 border-top'}
                    onClick={() => {
                      if (!showAction) {
                        setShowAction(true);
                        setSelectedPayment(items);
                      }
                    }}
                  >
                    <div className='w-100'>
                      <div className='w-100 d-flex align-items-center justify-content-between'>
                        <span>{items.name}{items.isCompleted ? <Badge pill bg='success' className='ms-2 fw-light'>Done</Badge> : <Badge bg='info' pill className='ms-2 fw-light'>Not Started, Yet!</Badge>}</span>
                        <span className='ps-3'>
                          <span>{items.value}{items.valueType === "percent" ? "% BP" : null}</span>
                          {
                            items.other ?
                              <span> + {items.other}{items.valueType === "percent" ? "% AC" : null}</span>
                              :
                              null
                          }
                        </span>
                      </div>
                      {
                        items.description ?
                          <p className='text-muted text-start mb-0'>
                            <small>- {items.description}</small>
                          </p>
                          :
                          null
                      }
                      {
                        items.isCompleted ?
                          <div className='row mt-2'>
                            <div className='col-6 text-start small'>Completion :{format(new Date(items.completionDate && items.completionDate.seconds * 1000), "dd/MM/yyyy")}</div>
                            <div className='col-6 text-end small'>Due Date : {format(new Date(items.nextPaymentDueDate && items.nextPaymentDueDate.seconds * 1000), "dd/MM/yyyy")}</div>
                          </div>
                          :
                          null
                      }
                    </div>
                  </Button>
                )
              })
            }
          </>
          :
          <div className='mx-3 mb-3 mt-4'>
            <Button
              variant='white'
              className='w-100 py-5 border-long-dashed rounded border-0 shadow-none'
              onClick={() => {
                setPlanID(planID);
                handleShowPayment();
              }}
            >
              <MdAdd size={20} color={`var(--bs-primary)`} />
              <span className='ms-1 text-primary'>Create Payments</span>
            </Button>
          </div>
      }

      <Modal
        show={showAction}
        onHide={() => setShowAction(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <div className='modal-header'>
          <h5 className='mb-0'>Mark as Completed</h5>
          <Button variant='none' className='btn-close px-3' onClick={() => setShowAction(false)} />
        </div>
        <div className='modal-body p-3'>
          <Form.Group className="mb-3" controlId="name">
            <Form.Label>Name of the Task</Form.Label>
            <p>{selectedPayment && selectedPayment.name}</p>
          </Form.Group>
          {
            selectedPayment && selectedPayment.description ?
              < Form.Group className="mb-3" controlId="name">
                <Form.Label>Description</Form.Label>
                <p>{selectedPayment && selectedPayment.description}</p>
              </Form.Group>
              :
              null
          }
          <div className='row'>
            <div className='col-6'>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>Date of Completion</Form.Label>
                <Form.Control
                  type="date"
                  value={selectedPayment && selectedPayment.completionDate ? format(selectedPayment.completionDate, "yyyy-MM-dd") : ''}
                  onChange={(event) => {
                    setSelectedPayment({ ...selectedPayment, completionDate: new Date(event.target.value) })
                    setDueDate(new Date(calculatedDueDate));
                  }}
                />
              </Form.Group>
            </div>
            <div className='col-6'>
              <Form.Group>
                <Form.Label>Payment Terms</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="number"
                    value={paymentTerms}
                    onChange={(event) => {
                      setPaymentTerms(event.target.value);
                      setDueDate(new Date(calculatedDueDate));
                    }}
                    className='border-right-0'
                  />
                  <InputGroup.Text className='py-1'>Days</InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </div>
          </div>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Due Date</Form.Label>
            <p>{calculatedDueDate && format(new Date(calculatedDueDate), "dd/MM/yyyy")}</p>
          </Form.Group>
        </div>
        <div className='modal-footer px-3 align-items-center justify-content-between'>
          <Button
            variant='danger'
            size='sm'
            className='py-2 btn-width'
            onClick={() => {
              setShowAction(false);
              setSelectedPayment(null);
            }}
          >
            Cancel
          </Button>
          <Button
            variant='success'
            size='sm'
            className='py-2 btn-width'
            onClick={() => handlePaymentAction(calculatedDueDate)}
          >
            Completed
          </Button>
        </div>
      </Modal >
    </>
  )
}

export default PaymentPlans;
